import axios from "axios";

// apiFss.defaults.headers.common["Authorization"] = "Token " + tokenFss;

// const URL = "/api/v1/fsh/presigned-url/get";

// export const createFSSPreSignedUrl = (fileName, callback) => {
//   apiFss
//     .post(URL, { file_name: fileName, method: "put" })
//     .then((response) => callback(response.data.data))
//     .catch((err) => {
//       Toast("warning", err.response.data.message);
//     });
// };

const apiUploadFile = (presigned_url) =>
  axios.create({
    baseURL: presigned_url,
    headers: {
      "Content-Type": false,
    },
  });

export const uploadFileToFSS = (presigned_url, formData, callback) => {
  const api = apiUploadFile(presigned_url);

  api
    .put("", formData, {
      headers: {
        "Content-Type": "",
      },
    })
    .then((response) => callback(response))
    .catch((err) => {
      console.log("🚀 ~ uploadFileToFSS ~ err:", err);
      callback(err);
    });
};
